import { FieldType, BaseRateRequest } from '@pmp/api';
import { CrudMode, FormItem, SelectsOptions, RenderFormItem, transformUppercaseNoSpaces } from '@ohpen/enso-ui';
import { DEFAULT_TEXT_MAX_LENGTH_SHORT, HALF_WIDTH, crudSection, textLimitProps } from '@pmp/utils';
import { renderReadonlyWithUnit } from '@pmp/components';

export const getBaseRatesFormSchema = (
  selectsOptions: SelectsOptions,
  renderAlert: RenderFormItem<BaseRateRequest>,
  mode?: CrudMode | null,
): FormItem[] => [
  {
    renderFormItem: renderAlert,
  },
  crudSection('global.labels.details', mode, [
    {
      title: 'pmp.baseRates.labels.baseRateId',
      dataIndex: 'code',
      colProps: HALF_WIDTH,
      formItemProps: {
        required: mode === CrudMode.CREATE,
        getValueFromEvent: transformUppercaseNoSpaces,
      },
      fieldProps: {
        disabled: mode !== CrudMode.CREATE,
        ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
      },
    },
    {
      title: 'pmp.baseRates.labels.baseRateName',
      dataIndex: 'name',
      colProps: HALF_WIDTH,
      formItemProps: {
        required: true,
      },
      fieldProps: {
        disabled: mode === CrudMode.VIEW,
        ...textLimitProps(DEFAULT_TEXT_MAX_LENGTH_SHORT),
      },
    },
    {
      title: 'pmp.baseRates.labels.variabilityType',
      dataIndex: 'variabilityType',
      valueType: 'select',
      colProps: HALF_WIDTH,
      formItemProps: {
        required: true,
      },
      fieldProps: {
        options: selectsOptions[FieldType.VARIABILITY_TYPE],
        disabled: mode !== CrudMode.CREATE,
      },
    },
    {
      title: 'pmp.baseRates.labels.rate',
      dataIndex: 'amount',
      valueType: 'percent',
      dependencies: ['variabilityType'],
      colProps: HALF_WIDTH,
      renderReadonly: renderReadonlyWithUnit({ suffix: '%' }),
      formItemProps: form => ({
        required: true,
      }),
      fieldProps: {
        disabled: mode !== CrudMode.CREATE,
      },
    },
  ]),
  crudSection('global.labels.validity', mode, [
    {
      title: 'pmp.baseRates.labels.startDate',
      dataIndex: 'startDate',
      valueType: 'date',
      dependencies: ['variabilityType'],
      colProps: HALF_WIDTH,
      formItemProps: form => ({
        required: true,
      }),
      fieldProps: {
        disabled: mode !== CrudMode.CREATE,
      },
    },
    {
      title: 'pmp.baseRates.labels.endDate',
      dataIndex: 'endDate',
      valueType: 'date',
      colProps: HALF_WIDTH,
      formItemProps: {
        hidden: mode !== CrudMode.VIEW,
      },
      fieldProps: {
        disabled: true,
      },
    },
  ]),
];

export const getInterestRatesFormSchema = (mode?: CrudMode | null): FormItem[] => [
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    valueType: 'percent',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      precision: 4,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    valueType: 'date',
    formItemProps: {
      required: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    formItemProps: {
      hidden: mode === CrudMode.CREATE,
    },
    fieldProps: {
      disabled: true,
    },
  },
];
